'use strict';

export default function offerRecommendedOrderBy () {
    let $dropdown = $('#offerRecommendedOrderBy');

    let getUrlParameter = (name) => {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    let initialize = () => {
        $dropdown.val(getUrlParameter($dropdown.attr('name')));
        $dropdown.trigger('chosen:updated');
    };

    if ($dropdown.length) {

        let controlName = $dropdown.attr('name');

        initialize();

        $dropdown.on('change', function (e) {
            e.preventDefault();

            let redirect = '?';
            let $this = $(this);
            if ($this.val()) {
                redirect += controlName + '=' + $this.val();
            }

            window.location.href = redirect;
        });
    };
}
